// extracted by mini-css-extract-plugin
export default {"infoBox":"InfoBox_infoBox__j9Ds-","title":"InfoBox_title__R8-qM","value":"InfoBox_value__K1nNw"};